import PropTypes             from 'prop-types';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import styles                from './email-info-block.module.scss';

const EmailInfoBlock = ({
  email,
  onClickChangeEmail,
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.text}>
        Сейчас вам придет e-mail с кодом
      </div>
      <div className={styles.value}>
        {email}
      </div>
      <div
        className={styles.change_button}
        onClick={onClickChangeEmail}
      >
        <ArrowBackOutlinedIcon/>
        <span>Изменить e-mail</span>
      </div>
    </div>
  )
};

EmailInfoBlock.propTypes = {
  email: PropTypes.string.isRequired,
  onClickChangeEmail: PropTypes.func.isRequired
};

export default EmailInfoBlock;